import React, { useCallback } from 'react';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

const WebCamera = ({
    onPhotoTaken,
    onPhotoError,
    onPhotoStopped,
}) => {
    const handleTakePhoto = useCallback((dataUri) => {
        console.log('takePhoto');
        onPhotoTaken(dataUri);
    }, []);

    const handleTakePhotoAnimationDone = useCallback((dataUri) => {
        console.log('takePhoto');
        onPhotoTaken(dataUri);
    }, []);

    const handleCameraError = useCallback((error) => {
        console.log('handleCameraError', error);
        onPhotoError(error);
    }, []);

    const handleCameraStart = useCallback((stream) => {
        console.log('handleCameraStart');
    }, []);

    const handleCameraStop = useCallback(() => {
        console.log('handleCameraStop');
        onPhotoStopped();
    }, []);

    return (
        <>
            <Camera
                onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
                onTakePhotoAnimationDone = { (dataUri) => { handleTakePhotoAnimationDone(dataUri); } }
                onCameraError = { (error) => { handleCameraError(error); } }
                idealFacingMode = {FACING_MODES.ENVIRONMENT}
                idealResolution = {{width: 640, height: 480}}
                imageType = {IMAGE_TYPES.JPG}
                imageCompression = {0.97}
                isMaxResolution = {true}
                isImageMirror = {false}
                isSilentMode = {false}
                isDisplayStartCameraError = {true}
                isFullscreen = {false}
                sizeFactor = {1}
                onCameraStart = { (stream) => { handleCameraStart(stream); } }
                onCameraStop = { () => { handleCameraStop(); } }
            />
        </>
    );
}

export default WebCamera;